module.exports = __webpack_public_path__ + "static/img/blockchain.55aab94.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/blockchain.png
// module id = KVN8
// module chunks = 1